import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "node-overview",
  "aria-label": "Loaded node infrastructure overview"
}
const _hoisted_2 = { class: "overview-heading" }
const _hoisted_3 = { class: "overview-metrics" }
const _hoisted_4 = { class: "metric" }
const _hoisted_5 = { class: "metric-note" }
const _hoisted_6 = { class: "metric" }
const _hoisted_7 = { class: "metric-total" }
const _hoisted_8 = { class: "metric" }
const _hoisted_9 = { class: "metric" }
const _hoisted_10 = { class: "capacity" }
const _hoisted_11 = { class: "metric-note" }
const _hoisted_12 = { class: "metric" }
const _hoisted_13 = { class: "capacity" }
const _hoisted_14 = { class: "metric-note" }
const _hoisted_15 = {
  key: 0,
  class: "distribution-row"
}
const _hoisted_16 = { class: "distribution" }
const _hoisted_17 = {
  key: 0,
  class: "distribution-chip",
  title: "No role label in the loaded snapshot; unavailable as a server filter"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["aria-pressed", "title", "onClick"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = {
  key: 0,
  class: "distribution"
}
const _hoisted_22 = ["aria-pressed", "title", "onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 0,
  class: "unknown-zones"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NodePoolMembership = _resolveComponent("NodePoolMembership")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Infrastructure snapshot", -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.scopeText), 1)
    ]),
    _cache[17] || (_cache[17] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "metric-label" }, "Loaded nodes", -1)),
        _createElementVNode("strong", null, _toDisplayString(_ctx.overview.total), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.paginated || _ctx.partialScope ? 'Partial cluster inventory' : 'Available in this view'), 1)
      ]),
      _cache[8] || (_cache[8] = _createTextVNode()),
      _createElementVNode("div", _hoisted_6, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "metric-label" }, "Ready", -1)),
        _createElementVNode("strong", null, [
          _createTextVNode(_toDisplayString(_ctx.overview.ready), 1),
          _createElementVNode("span", _hoisted_7, " / " + _toDisplayString(_ctx.overview.total), 1)
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["metric-note", { attention: _ctx.overview.notReady > 0 }])
        }, _toDisplayString(_ctx.readinessText), 3)
      ]),
      _cache[9] || (_cache[9] = _createTextVNode()),
      _createElementVNode("div", _hoisted_8, [
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "metric-label" }, "Cordoned", -1)),
        _createElementVNode("strong", null, _toDisplayString(_ctx.overview.cordoned), 1),
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "metric-note" }, "Scheduling disabled", -1))
      ]),
      _cache[10] || (_cache[10] = _createTextVNode()),
      _createElementVNode("div", _hoisted_9, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "metric-label" }, "Reported allocatable CPU", -1)),
        _createElementVNode("strong", _hoisted_10, _toDisplayString(_ctx.cpuText), 1),
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.overview.cpuReported) + " of " + _toDisplayString(_ctx.overview.total) + " nodes report capacity", 1)
      ]),
      _cache[11] || (_cache[11] = _createTextVNode()),
      _createElementVNode("div", _hoisted_12, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "metric-label" }, "Reported allocatable memory", -1)),
        _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.memoryText), 1),
        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.overview.memoryReported) + " of " + _toDisplayString(_ctx.overview.total) + " nodes report capacity", 1)
      ])
    ]),
    _cache[18] || (_cache[18] = _createTextVNode()),
    (_ctx.overview.total || _ctx.selectedRole || _ctx.selectedZone || _ctx.roleChoices.length || _ctx.zoneChoices.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "distribution-label" }, "Role labels", -1)),
            _cache[13] || (_cache[13] = _createTextVNode()),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: role.label
              }, [
                (_ctx.paginated && role.label === 'Role unspecified')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                      _createTextVNode(_toDisplayString(role.label) + " ", 1),
                      (role.count !== undefined)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_18, _toDisplayString(role.count), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "distribution-chip",
                      "aria-pressed": _ctx.selectedRole === role.label,
                      title: `Filter inventory by role: ${role.label}`,
                      onClick: ($event: any) => (_ctx.$emit('toggle-role', role.label))
                    }, [
                      _createTextVNode(_toDisplayString(role.label) + " ", 1),
                      (role.count !== undefined)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_20, _toDisplayString(role.count), 1))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_19))
              ], 64))
            }), 128))
          ]),
          _cache[15] || (_cache[15] = _createTextVNode()),
          (_ctx.zones.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "distribution-label" }, "Zone labels", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zones, (zone) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: zone.label,
                    type: "button",
                    "aria-pressed": _ctx.selectedZone === zone.label,
                    class: "distribution-chip",
                    title: `Filter inventory by zone: ${zone.label}`,
                    onClick: ($event: any) => (_ctx.$emit('toggle-zone', zone.label))
                  }, [
                    _createTextVNode(_toDisplayString(zone.label) + " ", 1),
                    (zone.count !== undefined)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_23, _toDisplayString(zone.count), 1))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_22))
                }), 128)),
                (_ctx.overview.zoneReported < _ctx.overview.total)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.overview.total - _ctx.overview.zoneReported) + " unlabelled", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _cache[16] || (_cache[16] = _createTextVNode()),
          (_ctx.selectedRole || _ctx.selectedZone)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "clear-filters",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clear-filters')))
              }, "\n        Clear inventory filters\n      "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _cache[19] || (_cache[19] = _createTextVNode()),
    _createVNode(_component_NodePoolMembership, {
      nodes: _ctx.nodes,
      "cluster-id": _ctx.clusterId,
      "cluster-name": _ctx.clusterName
    }, null, 8, ["nodes", "cluster-id", "cluster-name"])
  ]))
}